import { useEffect, useMemo, useState } from 'react';
import { buildEventParticipantScopeTabs } from './eventParticipantsPanelDataUtils';

export default function useEventParticipantPartScope({
  effectiveGroupEvents = [],
  selectedEventId = '',
  pickFirstString,
}) {
  const [participantPartScopeEventUuid, setParticipantPartScopeEventUuid] = useState(() => (
    String(selectedEventId || effectiveGroupEvents?.[0]?.event_uuid || '')
  ));

  useEffect(() => {
    if (effectiveGroupEvents.length > 1) {
      setParticipantPartScopeEventUuid((prev) => {
        const exists = effectiveGroupEvents.some(
          (event) => String(event?.event_uuid || '') === String(prev)
        );
        if (exists) return prev;
        const selectedExists = effectiveGroupEvents.some(
          (event) => String(event?.event_uuid || '') === String(selectedEventId)
        );
        if (selectedExists) return String(selectedEventId);
        const primary = effectiveGroupEvents.find((event) => event?.is_primary === true);
        return String(primary?.event_uuid || effectiveGroupEvents[0]?.event_uuid || '');
      });
      return;
    }
    const singleEventUuid = String(
      effectiveGroupEvents?.[0]?.event_uuid || selectedEventId || ''
    ).trim();
    setParticipantPartScopeEventUuid(singleEventUuid || 'all');
  }, [effectiveGroupEvents, selectedEventId]);

  const participantPartScopeTabs = useMemo(() => {
    return buildEventParticipantScopeTabs({
      effectiveGroupEvents,
      pickFirstString,
    });
  }, [effectiveGroupEvents, pickFirstString]);

  return {
    participantPartScopeEventUuid,
    setParticipantPartScopeEventUuid,
    participantPartScopeTabs,
  };
}
